import React from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { Checkbox } from 'pretty-checkbox-react';

const Group = props => {
  const {
    currentExtension,
    extensionsLogged,
    groupsLoginLogout,
    handleChangeLoginLogoutGroup,
    optionsStatus,
    handleChangeStatusPause,
    isFetching,
    groupsAvailable,
    statusId,
    pauseSelected,
    getPauseStatus
  } = props;

  const customStyle = {
    control: provided => ({
      ...provided,
      borderRadius: '0px',
      '&:hover': {
        color: '#495057',
        backgroundColor: '#fff',
        borderColor: '#80bdff',
        outline: 0,
        boxShadow: '0 0 0 .2rem rgba(0,123,255,.25)'
      }
    }),
    menu: provided => ({ ...provided, marginTop: '1px' }),
    downchevron: provided => ({ ...provided, borderRadius: '100px' })
  };

  const customThemes = theme => ({
    ...theme,
    colors: { ...theme.colors, primary: '#80bdff' }
  });

  return (
    <React.Fragment>
      <li>
        <div className="form-group ml-2 mr-2">
          <label className="p-0 sidebar-subtitle">Ramal Atual</label>
          <select
            className="form-control"
            id="currentExtension"
            name="currentExtension"
            ref={currentExtension}
            disabled={isFetching || extensionsLogged.length < 2}
          >
            {extensionsLogged.map(item => {
              const { id, number } = item;
              return (
                <option key={id} id={id} value={number}>
                  {number}
                </option>
              );
            })}
          </select>
        </div>
      </li>
      <li>
        <div className="form-group ml-2 mr-2">
          <label className="sidebar-subtitle">Grupos Disponíveis</label>
          <div id="groups-container" ref={groupsLoginLogout}>
            {groupsAvailable.length ? (
              groupsAvailable.map(grp => {
                return (
                  <Checkbox
                    key={grp.id}
                    id={grp.id}
                    inputProps={{ name: grp.number }}
                    type="checkbox"
                    color="primary-o"
                    animation="smooth"
                    onChange={handleChangeLoginLogoutGroup}
                    disabled={isFetching}
                    checked={grp.logged}
                  >
                    <span className="sidebar-subtitle">{`${grp.number} - ${grp.name}`}</span>
                  </Checkbox>
                );
              })
            ) : (
              <span>Nenhum Grupo Configurado</span>
            )}
          </div>
        </div>
      </li>
      <li>
        <div className="form-group ml-2 mr-2">
          <label className="sidebar-subtitle">Pausa Usuário</label>
          <div className="form-row m-0">
            <div className="w-75 pl-0">
              <Select
                value={optionsStatus.find(opt => opt.value === statusId)}
                onChange={handleChangeStatusPause}
                isDisabled={
                  isFetching ||
                  !groupsAvailable.filter(grp => grp.logged).length ||
                  !optionsStatus.length
                }
                options={optionsStatus.filter(opt => opt.value !== statusId)}
                isSearchable={false}
                theme={customThemes}
                styles={customStyle}
                ref={pauseSelected}
              />
            </div>
            <div className="col pr-0">
              <button
                type="button"
                className="btn btn-info w-100"
                title="Atualizar Listagem"
                disabled={isFetching}
                onClick={getPauseStatus}
              >
                <i className="fa fa-sync-alt" />
              </button>
            </div>
          </div>
        </div>
      </li>
      <li>{isFetching && <p className="text-center">Processando...</p>}</li>
    </React.Fragment>
  );
};

Group.propTypes = {
  isFetching: PropTypes.bool,
  currentExtension: PropTypes.object,
  extensionsLogged: PropTypes.array,
  groupsLoginLogout: PropTypes.object,
  handleChangeLoginLogoutGroup: PropTypes.func,
  optionsStatus: PropTypes.array,
  handleChangeStatusPause: PropTypes.func,
  groupsAvailable: PropTypes.array,
  statusId: PropTypes.string,
  pauseSelected: PropTypes.object,
  getPauseStatus: PropTypes.func
};

export default Group;
